import Reveal from "@/components/feature/Reveal";
import { evidenceTypes } from "@/mocks/homeData";

export default function EvidenceEntrances() {
  return (
    <section id="entrances" className="w-full px-4 md:px-10 py-16 md:py-24 bg-background-50">
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-5">
        <Reveal className="max-w-2xl">
          <p className="font-label text-xs md:text-sm tracking-[0.24em] text-primary-600">按类型进入</p>
          <h2 className="mt-4 font-heading font-black text-2xl md:text-4xl text-foreground-950">
            先挑你想看的材料类型
          </h2>
          <p className="mt-4 font-body text-sm md:text-base leading-7 text-foreground-600">
            四类材料各自归档，入口保持在同一屏内。想看对账链路就进实锤，想还原对话上下文就进聊天记录。
          </p>
        </Reveal>
        <Reveal delay={80}>
          <p className="font-label text-xs md:text-sm text-foreground-500 whitespace-nowrap">
            共 3,985 份材料 · 持续整理中
          </p>
        </Reveal>
      </div>

      <div className="mt-10 md:mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
        {evidenceTypes.map((type, index) => (
          <Reveal key={type.id} as="article" delay={index * 60}>
            <a
              href={type.href}
              className="group flex flex-col h-full rounded-lg border border-background-200 bg-background-100 p-5 md:p-6 hover:border-primary-300 hover:bg-primary-50/60 transition-colors"
            >
              <span className="w-12 h-12 flex items-center justify-center rounded-md bg-primary-500 text-background-50 dark:text-foreground-950">
                <i className={`${type.icon} text-2xl`} aria-hidden="true"></i>
              </span>

              <h3 className="mt-5 font-heading font-bold text-lg md:text-xl text-foreground-950">
                {type.name}
              </h3>
              <p className="mt-3 font-body text-sm leading-6 text-foreground-600 flex-1">{type.brief}</p>

              <div className="mt-6 pt-5 border-t border-background-200 flex items-center justify-between">
                <span className="flex flex-col">
                  <span className="font-heading font-black text-lg text-foreground-950">{type.count}</span>
                  <span className="font-label text-xs text-foreground-500">{type.unit}</span>
                </span>
                <span className="inline-flex items-center gap-1.5 font-label text-sm text-primary-600 group-hover:gap-3 transition-all">
                  进入
                  <i className="ri-arrow-right-line text-base" aria-hidden="true"></i>
                </span>
              </div>
            </a>
          </Reveal>
        ))}
      </div>
    </section>
  );
}